;
/*!
 * Utilitaires Productions Les Affranchis
 */
if ( typeof PLA == 'undefined' ) {
	PLA = {};
}

if ( typeof PLA.UTILS == 'undefined' ) {
	PLA.UTILS = {};
}

PLA.UTILS.debounce = function ( func, wait, immediate ) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if ( !immediate ) func.apply( context, args );
		};
		var callNow = immediate && !timeout;
		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
		if ( callNow ) func.apply( context, args );
	};
};



PLA.UTILS.modeTfo = function() {
	return 'mode-tfo' == $( 'html' ).attr( 'id' );
}


/*! modernizr 3.3.1 (Custom Build) | MIT *
 * http://modernizr.com/download/?-csstransforms3d-preserve3d-setclasses !*/
!function ( e, n, t ) {
	function r ( e, n ) {
		return typeof e === n
	}

	function s () {
		var e, n, t, s, o, i, a;
		for ( var f in C )if ( C.hasOwnProperty( f ) ) {
			if ( e = [], n = C[ f ], n.name && (e.push( n.name.toLowerCase() ), n.options && n.options.aliases && n.options.aliases.length) )for ( t = 0; t < n.options.aliases.length; t++ )e.push( n.options.aliases[ t ].toLowerCase() );
			for ( s = r( n.fn, "function" ) ? n.fn() : n.fn, o = 0; o < e.length; o++ )i = e[ o ], a = i.split( "." ), 1 === a.length ? Modernizr[ a[ 0 ] ] = s : (!Modernizr[ a[ 0 ] ] || Modernizr[ a[ 0 ] ] instanceof Boolean || (Modernizr[ a[ 0 ] ] = new Boolean( Modernizr[ a[ 0 ] ] )), Modernizr[ a[ 0 ] ][ a[ 1 ] ] = s), g.push( (s ? "" : "no-") + a.join( "-" ) )
		}
	}

	function o ( e ) {
		var n = w.className, t = Modernizr._config.classPrefix || "";
		if ( x && (n = n.baseVal), Modernizr._config.enableJSClass ) {
			var r = new RegExp( "(^|\\s)" + t + "no-js(\\s|$)" );
			n = n.replace( r, "$1" + t + "js$2" )
		}
		Modernizr._config.enableClasses && (n += " " + t + e.join( " " + t ), x ? w.className.baseVal = n : w.className = n)
	}

	function i () {
		return "function" != typeof n.createElement ? n.createElement( arguments[ 0 ] ) : x ? n.createElementNS.call( n, "http://www.w3.org/2000/svg", arguments[ 0 ] ) : n.createElement.apply( n, arguments )
	}

	function a () {
		var e = n.body;
		return e || (e = i( x ? "svg" : "body" ), e.fake = !0), e
	}

	function f ( e, t, r, s ) {
		var o, f, l, u, p = "modernizr", d = i( "div" ), c = a();
		if ( parseInt( r, 10 ) )for ( ; r--; )l = i( "div" ), l.id = s ? s[ r ] : p + (r + 1), d.appendChild( l );
		return o = i( "style" ), o.type = "text/css", o.id = "s" + p, (c.fake ? c : d).appendChild( o ), c.appendChild( d ), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild( n.createTextNode( e ) ), d.id = p, c.fake && (c.style.background = "", c.style.overflow = "hidden", u = w.style.overflow, w.style.overflow = "hidden", w.appendChild( c )), f = t( d, e ), c.fake ? (c.parentNode.removeChild( c ), w.style.overflow = u, w.offsetHeight) : d.parentNode.removeChild( d ), !!f
	}

	function l ( e, n ) {
		return function () {
			return e.apply( n, arguments )
		}
	}

	function u ( e, n, t ) {
		var s;
		for ( var o in e )if ( e[ o ] in n )return t === !1 ? e[ o ] : (s = n[ e[ o ] ], r( s, "function" ) ? l( s, t || n ) : s);
		return !1
	}

	function p ( e, n ) {
		return !!~("" + e).indexOf( n )
	}

	function d ( e ) {
		return e.replace( /([a-z])-([a-z])/g, function ( e, n, t ) {
			return n + t.toUpperCase()
		} ).replace( /^-/, "" )
	}

	function c ( e ) {
		return e.replace( /([A-Z])/g, function ( e, n ) {
			return "-" + n.toLowerCase()
		} ).replace( /^ms-/, "-ms-" )
	}

	function m ( n, r ) {
		var s = n.length;
		if ( "CSS" in e && "supports" in e.CSS ) {
			for ( ; s--; )if ( e.CSS.supports( c( n[ s ] ), r ) )return !0;
			return !1
		}
		if ( "CSSSupportsRule" in e ) {
			for ( var o = []; s--; )o.push( "(" + c( n[ s ] ) + ":" + r + ")" );
			return o = o.join( " or " ), f( "@supports (" + o + ") { #modernizr { position: absolute; } }", function ( e ) {
				return "absolute" == getComputedStyle( e, null ).position
			} )
		}
		return t
	}

	function h ( e, n, s, o ) {
		function a () {
			l && (delete k.style, delete k.modElem)
		}

		if ( o = r( o, "undefined" ) ? !1 : o, !r( s, "undefined" ) ) {
			var f = m( e, s );
			if ( !r( f, "undefined" ) )return f
		}
		for ( var l, u, c, h, v, y = [ "modernizr", "tspan" ]; !k.style; )l = !0, k.modElem = i( y.shift() ), k.style = k.modElem.style;
		for ( c = e.length, u = 0; c > u; u++ )if ( h = e[ u ], v = k.style[ h ], p( h, "-" ) && (h = d( h )), k.style[ h ] !== t ) {
			if ( o || r( s, "undefined" ) )return a(), "pfx" == n ? h : !0;
			try {
				k.style[ h ] = s
			} catch (g) {
			}
			if ( k.style[ h ] != v )return a(), "pfx" == n ? h : !0
		}
		return a(), !1
	}

	function v ( e, n, t, s, o ) {
		var i = e.charAt( 0 ).toUpperCase() + e.slice( 1 ), a = (e + " " + E.join( i + " " ) + i).split( " " );
		return r( n, "string" ) || r( n, "undefined" ) ? h( a, n, s, o ) : (a = (e + " " + T.join( i + " " ) + i).split( " " ), u( a, n, t ))
	}

	function y ( e, n, r ) {
		return v( e, t, t, n, r )
	}

	var g = [], C = [], S = {
		_version    : "3.3.1",
		_config     : { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
		_q          : [],
		on          : function ( e, n ) {
			var t = this;
			setTimeout( function () {
				n( t[ e ] )
			}, 0 )
		},
		addTest     : function ( e, n, t ) {
			C.push( { name: e, fn: n, options: t } )
		},
		addAsyncTest: function ( e ) {
			C.push( { name: null, fn: e } )
		}
	}, Modernizr = function () {
	};
	Modernizr.prototype = S, Modernizr = new Modernizr;
	var w = n.documentElement, x = "svg" === w.nodeName.toLowerCase(), _ = "CSS" in e && "supports" in e.CSS, b = "supportsCSS" in e;
	Modernizr.addTest( "supports", _ || b );
	var P = S.testStyles = f, z = "Moz O ms Webkit", E = S._config.usePrefixes ? z.split( " " ) : [];
	S._cssomPrefixes = E;
	var T = S._config.usePrefixes ? z.toLowerCase().split( " " ) : [];
	S._domPrefixes = T;
	var N = { elem: i( "modernizr" ) };
	Modernizr._q.push( function () {
		delete N.elem
	} );
	var k = { style: N.elem.style };
	Modernizr._q.unshift( function () {
		delete k.style
	} ), S.testAllProps = v, S.testAllProps = y, Modernizr.addTest( "csstransforms3d", function () {
		var e = !!y( "perspective", "1px", !0 ), n = Modernizr._config.usePrefixes;
		if ( e && (!n || "webkitPerspective" in w.style) ) {
			var t, r = "#modernizr{width:0;height:0}";
			Modernizr.supports ? t = "@supports (perspective: 1px)" : (t = "@media (transform-3d)", n && (t += ",(-webkit-transform-3d)")), t += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", P( r + t, function ( n ) {
				e = 7 === n.offsetWidth && 18 === n.offsetHeight
			} )
		}
		return e
	} ), Modernizr.addTest( "preserve3d", y( "transformStyle", "preserve-3d" ) ), s(), o( g ), delete S.addTest, delete S.addAsyncTest;
	for ( var j = 0; j < Modernizr._q.length; j++ )Modernizr._q[ j ]();
	e.Modernizr = Modernizr
}( window, document );


PLA.UTILS.areWeMobile = function () {
	if ( typeof jqPla == 'undefined' ) {
		return;
	}

	if ( typeof PLA.UTILS.mobileDetectionElement == 'undefined' ) {
		PLA.UTILS.mobileDetectionElement = jqPla( '<span class="mobile-detector" />' ).appendTo( 'body' );
	}

	return PLA.UTILS.mobileDetectionElement.css( 'display' ) != 'none';
}


PLA.UTILS.scrollTop = {

	init      : function () {
		var $ = jqPla,
			_this = PLA.UTILS.scrollTop;

		_this.$window = $( window );
		_this.$body = $( 'body' );
		_this.$bodyhtml = $( 'html, body' );
		_this.$btnScrollTop = _this.$body.find( '.btn-back-to-top' );
		_this.scrollSpeed = 700; // in ms
		_this.offsetFromTopToShowBtn = _this.$window.height(); // Can also be an integer of pixels

		if ( _this.$btnScrollTop.length > 0 ) {
			_this.bindEvents();
		}
	},
	bindEvents: function () {
		var $ = jqPla,
			_this = PLA.UTILS.scrollTop;

		_this.$btnScrollTop.on( 'click', function ( e ) {
			e.preventDefault();

			_this.scrollTo();
		} );


		_this.$window.on( 'scroll', function ( e ) {
			var howLow = _this.$window.scrollTop();

			if ( howLow > _this.offsetFromTopToShowBtn ) {
				_this.$btnScrollTop.addClass( 'show' );
				//console.log("Showing scrollTop");
			} else {
				_this.$btnScrollTop.removeClass( 'show' );
				//console.log("Hiding scrollTop");
			}
		} );

		_this.$window.trigger( 'scroll' );
	},
	scrollTo  : function ( $target, extraOffset, scrollSpeed ) {
		var $ = jqPla,
			_this = PLA.UTILS.scrollTop,
			offsetFromTop = 0,
			scrollSpeedToUse = typeof scrollSpeed != 'undefined' ? scrollSpeed : _this.scrollSpeed;


		if ( typeof $target == 'undefined' || $target.length == 0 ) {
			$target = _this.$body;
		}


		if ( typeof extraOffset != 'undefined' ) {
			offsetFromTop = extraOffset
		}

		$( 'html, body' ).animate( {
			scrollTop: $target.offset().top + offsetFromTop
		},  scrollSpeedToUse);
	}

};


PLA.UTILS.getRandomIntInclusive = function ( min, max ) {
	min = Math.ceil( min );
	max = Math.floor( max );
	return Math.floor( Math.random() * (max - min + 1) ) + min;
}

PLA.UTILS.disabledDisabledLinks = function () {
	var $ = jqPla;

	$( 'a.disabled' ).on( 'click', function ( e ) {
		e.preventDefault();
	} )
}